//@flow
// we're currently using immutable v4 configs since they are a lot
// better but they are inaccurate
// $FlowFixMe
import { fromJS, Iterable } from 'immutable';
import memoize from 'memoizee';

// until we move to immutable v4 that defines isImmutable, copy the approach used by nuclear-js
// https://github.com/optimizely/nuclear-js/blob/master/src/immutable-helpers.js
export function isImmutable(data:any):boolean {
  return Iterable.isIterable(data);
}

export function toImmutable(data:any):any {
  return isImmutable(data) ? data : fromJS(data);
}

export function toJS(data:any):any {
  return (data && data.toJS && data.toJS()) || data;
}

export const toJSCached = memoize(toJS);
